<div class="container">
    <span class="title-container">
        <img src="{{img}}" alt="" class="title-img">
        <h1 class="section-title" [id]="id">{{title}}</h1>
    </span>
    <div class="section-body">
        <ng-content></ng-content>
    </div>
</div>